import { AppService, APP_MODE } from 'src/app/app.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';
import { RSAHelper } from 'src/app/shared/auth/rsa-helper';
import { AuthOnlineService } from './auth-online.service';
import { AuthOfflineService } from './auth-offline.service';
import { AuthService } from './auth.service';
import { UnitOfWorkOfflineDao } from '../../daos/unitofwork-offline.dao';

const AuthServiceFactory = (appService: AppService, httpClient: HttpClient, apiService: ApiService, rsaHelper: RSAHelper, unitOfWork: UnitOfWorkOfflineDao) =>
    appService.AppMode == APP_MODE.ONLINE_MODE ? 
    new AuthOnlineService(httpClient, apiService, rsaHelper, unitOfWork) : new AuthOfflineService(unitOfWork);

export const AuthServiceProvider = { 
    provide: AuthService,
    useFactory: AuthServiceFactory,
    deps: [AppService, HttpClient, ApiService, RSAHelper, UnitOfWorkOfflineDao]
};